import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actionName", "cardId", "cardInstanceId", "cardInstanceVersion", "context", "currentStateName", "senders", "id", "timestamp"];
import { generateUuid } from '../../util/generateUuid';
import { generateUniqueClientTimestamp } from '../../util/timestamps';
import { buildSenders } from '../../common-message-format/operators/buildSenders';
import InteractiveCardRequestMessage from '../records/InteractiveCardRequestMessage';
export const buildInteractiveCardRequestMessage = _ref => {
  let {
      actionName,
      cardId,
      cardInstanceId,
      cardInstanceVersion,
      context,
      currentStateName,
      senders = [],
      id,
      timestamp
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return new InteractiveCardRequestMessage(Object.assign({}, rest, {
    actionName,
    cardId,
    cardInstanceId,
    cardInstanceVersion,
    context,
    currentStateName,
    id: id !== null && id !== void 0 ? id : generateUuid(),
    senders: buildSenders(senders),
    timestamp: timestamp !== null && timestamp !== void 0 ? timestamp : generateUniqueClientTimestamp('buildInteractiveCardRequestMessage')
  }));
};